import React, { useState } from 'react';
import './homepage.css';
import { Col, Form, Row, Button, Modal, Image } from "react-bootstrap";
import Albums from "./Albums.js";
import db from './db.js'

function Homepage() {
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [albums, setAlbums] = useState([]);
  const [user, setUser] = useState("");

  const handleSignInClick = () => {
    setShowSignIn(true);
    setShowSignUp(false);
  };

  const handleSignUpClick = () => {
    setShowSignIn(false);
    setShowSignUp(true);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    console.log('Sign In:', email, password);
    let getAlbumsAndEntries = await db.getAllAlbums('',"","",email, password);
      try {
          setAlbums(getAlbumsAndEntries.albums.albums);
          if (getAlbumsAndEntries.albums.albums != ""){
              setUser("1");
          }
      } catch (error) {
          
      }       
          
      if (getAlbumsAndEntries.user == 0){
          setError("Wrong Email or Password!")
      }
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    console.log('Sign Up:', username, email, password);
    handleModalShow();

  };

  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  return (
    <div className="App">
      <div className="overlay"></div>
      <header>
        <h1>Sharkuha</h1>
        <p>Secure and private media sharing platform for pictures, videos & more.</p>
      </header>
      {showSignIn || showSignUp ||(
      <div className="auth-buttons">
        <button onClick={handleSignInClick}>Sign In</button>
        <button onClick={handleSignUpClick}>Sign Up</button>
      </div>
      )}

            {/* Sign In or Sign Up Form */}
            {showSignIn && (
        <div className="form-container">
          <h2>Sign In</h2>
          <form onSubmit={handleSignIn}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
            <p className="text-red fs-5 text-center" style={{color:"red"}}>{error}</p>
            <button type="submit" className="cta-button">Sign In</button>
          </form>
          <div className="signup-link">
            <p>Don't have an account? <button onClick={handleSignUpClick}>Sign Up</button></p>
          </div>
        </div>
      )}

      {showSignUp && (
        <div className="form-container">
          <h2>Sign Up</h2>
          <form onSubmit={handleSignUp}>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
            <button type="submit" className="cta-button">Sign Up</button>
          </form>
          <div className="signin-link">
            <p>Already have an account? <button onClick={handleSignInClick}>Sign In</button></p>
          </div>
        </div>
      )}

      <Modal show={showModal} onHide={handleModalClose}>
                              <Modal.Header closeButton>
                                  <Modal.Title></Modal.Title>
                              </Modal.Header>
                              <Modal.Body style={{color:"black"}}> There seems to be a problem with signing up right now! Try again later.</Modal.Body>
                              <Modal.Footer>
                                  <Button variant="warning" onClick={handleModalClose}>
                                      Close
                                  </Button>
      
                              </Modal.Footer>
                          </Modal>
      {user ? <Albums allAlbums={albums}/>:
      <>
      {/* Features Section */}
      <div id="features" className="features-section">
        <div className="feature">
          <img src="https://img.icons8.com/ios/452/upload.png" alt="Security" />
          <h3>Security</h3>
          <p>Your content is protected with end-to-end encryption, ensuring your privacy at all times.</p>
        </div>
        <div className="feature">
          <img src="https://img.icons8.com/ios/452/lock.png" alt="Self Destructive" />
          <h3>Disappearing Media</h3>
          <p>Share your photos or videos with a timer, making them disappear after being viewed.</p>
        </div>
        <div className="feature">
          <img src="https://img.icons8.com/ios/452/clock.png" alt="Easy Sharing" />
          <h3>Easy Sharing</h3>
          <p>Share photos and videos securely with a simple link, keeping control over who sees them.</p>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials">
        <h2>What Our Users Are Saying</h2>
        <div className="testimonial-item">
          <p>"I love how easy it is to share media privately with Sharkuha! The disappearing feature gives me peace of mind!"</p>
          <h3>Emma, Photographer</h3>
        </div>
        <div className="testimonial-item">
          <p>"The security is top-notch. I feel confident knowing my files are encrypted and shared safely."</p>
          <h3>John, Digital Artist</h3>
        </div>
        <div className="testimonial-item">
          <p>"I’ve never seen a service as easy to use and secure. Highly recommend Sharkuha for anyone who values privacy!"</p>
          <h3>Alice, Content Creator</h3>
        </div>
      </div>



      {/* Footer Section */}
      <footer>
        <p>&copy; 2025 Sharkuha. All rights reserved.</p>
      </footer>
      </>
      }
    </div>
  );
}

export default Homepage;
